export default __webpack_public_path__ + "static/media/church_icon.6e550645.svg";